module.exports = __webpack_public_path__ + "static/img/background.76ac0ad3.svg";